import Component from '../core/Component';
import enquire from 'enquire.js';
import { queries } from '../core/config';

export default class Social extends Component {

    constructor($element) {
        super($element);
        this.$intro = $('.section-intro');
        this.$footer = $('.section-footer');
    }

    prepare() {
        enquire.register(queries.mediumUp, {
            match: ::this.attachMediumUp,
            unmatch: ::this.detachMediumUP
        });

        enquire.register(queries.smallMax, {
            match: ::this.attachMobile,
            unmatch: ::this.detachMobile
        });
    }

    attachMediumUp() {
        if ($('.page-thankyou').length > 0) return;

        $(window).on('scroll orientationchange load', event => {
            if (this.checkDark(this.$element.offset().top)) {
                if (!this.$element.hasClass('is-dark')) {
                    this.$element.addClass('is-dark')
                }
            } else {
                this.$element.removeClass('is-dark')
            }
        });
    }

    detachMediumUP() {
        this.$element.removeClass('is-dark')
    }

    checkDark(offset) {
        const introTopBottom = [this.$intro.offset().top, this.$intro.offset().top + this.$intro.height()];
        const footerTopBottom = [this.$footer.offset().top, this.$footer.offset().top + this.$footer.height()];

        if (offset >= introTopBottom[0] && offset <= introTopBottom[1] || offset >= footerTopBottom[0] && offset <= footerTopBottom[1]) {
            return false // light
        } else {
            return true // dark
        }
    }


    attachMobile() {
        $(document).on('nav:open', event => this.$element.show());
        $(document).on('nav:close', event => this.$element.hide());
    }

    detachMobile() {

    }
}


// WEBPACK FOOTER //
// ./components/Social.js